// src/app/components/shared/shared.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Ant & CDK (ajusta a lo que use cada componente)
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule, NZ_ICONS } from 'ng-zorro-antd/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NzTabsModule } from 'ng-zorro-antd/tabs'; // kanban
import { NzModalModule } from 'ng-zorro-antd/modal';

import { CatalogTableComponent } from './catalog-table/catalog-table.component'; // tabla
import { CatalogKanbanComponent } from './catalog-kanban/catalog-kanban.component';
import {
  CatalogHistoryDrawerComponent
} from '@app/components/shared/catalog-history-drawer/catalog-history-drawer.component';
import {
  CatalogFilterDrawerComponent } from '@app/components/shared/catalog-filter-drawer/catalog-filter-drawer.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import {NzFormModule} from "ng-zorro-antd/form";
import {NzSelectModule} from "ng-zorro-antd/select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {NzDatePickerModule} from "ng-zorro-antd/date-picker";
import {NzInputModule} from "ng-zorro-antd/input";
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NgxEditorModule } from 'ngx-editor';
import { RichTextEditorComponent } from "@app/components/shared/rich-text-editor/rich-text-editor.component";
import * as AllIcons from '@ant-design/icons-angular/icons';
import { IconDefinition } from '@ant-design/icons-angular';

const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};

const icons: IconDefinition[] = Object.keys(antDesignIcons).map(
  key => antDesignIcons[key]
);

@NgModule({
  declarations: [
    CatalogTableComponent,
    CatalogKanbanComponent,
    CatalogHistoryDrawerComponent,
    CatalogFilterDrawerComponent,
    RichTextEditorComponent
  ],
  imports: [
    CommonModule,
    // módulos necesarios para los hijos:
    NzTableModule,
    NzCardModule,
    NzTagModule,
    NzTabsModule,
    NzPaginationModule,
    NzPopoverModule,
    NzButtonModule,
    NzIconModule,
    DragDropModule,
    NzDrawerModule,
    NzTimelineModule,
    NzFormModule,
    NzModalModule,
    NzSelectModule,
    NzDropdownModule,
    ReactiveFormsModule,
    NzDatePickerModule,
    NzInputModule,
    NzTooltipModule,
    NgxEditorModule,
    FormsModule,
  ],
  providers: [
    { provide: NZ_ICONS, useValue: icons }
  ],
  exports: [
    CatalogTableComponent,
    CatalogKanbanComponent,
    CatalogHistoryDrawerComponent,
    CatalogFilterDrawerComponent,
    RichTextEditorComponent
  ]
})
export class SharedModule {}
